import {
  // REQUEST_DATA_FROM_DIRECTORIES,
  SUCCESS_DATA_FROM_DIRECTORIES,

  // SUCCESS_DATA_FROM_DISTRICT,
  // SUCCESS_DATA_FROM_STREET,
  // SET_DISTRICT,
  SUCCESS_SET_DISTRICT,
  SET_STREET,
  // SET_CITY,
  SUCCESS_SET_CITY,
  SET_INDEX,
  SUCCESS_SET_DISTRICT_FACT,
  SET_STREET_FACT,
  SUCCESS_SET_CITY_FACT,
  SET_INDEX_FACT,
  GET_ERRORS,
  SET_BANKS,
  CLEAR_BANK,
  CLEAR_INDEX_AND_DISTRICT,
  CLEAR_CITY_STREET_BANKS,
  CLEAR_INDEX_AND_DISTRICT_FACT,
  CLEAR_CITY_STREET_BANKS_FACT,

} from '../actions/types';

export function getDataFromDirectories(
  state = {
    addressType: [],
    citizenShip: [],
    documentType: [],
    gender: [],
    region: [],
    relation: [],
    street: [],
    district: [],
    index: [],
    city: [],
    banks: {},
    reasonsRefusal: [],
    cancels: [],
    street_fact: [],
    district_fact: [],
    index_fact: [],
    city_fact: [],
    submitterType: [],
    indivent: [],
    legalActivity: [],
    freqPayment: [],
    error: ''
  },
  action
) {
  switch (action.type) {
    // case REQUEST_DATA_FROM_DIRECTORIES:
    //   return Object.assign({}, state, {
    //       isRequest: true,
    //   })
    case SUCCESS_DATA_FROM_DIRECTORIES:
      return Object.assign({}, state, {
        ...action.payload
        // addressType: action.addressType,
        // citizenShip: action.citizenShip,
        // documentType:action.documentType,
        // gender:action.gender,
        // region: action.region,
        // relation:action.relation,
        // submitterType:action.submitterType,
        // indivent:action.indivent,
        // legalActivity:action.legalActivity,
        // freqPayment:action.freqPayment
      });
    // case SUCCESS_DATA_FROM_DISTRICT:
    // return {
    //   ...state,
    //   district: action.district,
    // }
    case SET_BANKS:
      return {
        ...state,
        banks: action.payload
      };
    
    // case SUCCESS_DATA_FROM_STREET:
    // return {
    //   ...state,
    //   street: action.street,
    // }
    //case SET_DISTRICT:
    case SUCCESS_SET_DISTRICT:
      return {
        ...state,
        district: action.district
      };
    case SET_STREET:
      return {
        ...state,
        street: action.street
      };
    case SUCCESS_SET_CITY:
      return {
        ...state,
        city: action.city
      };
    case SET_INDEX:
      return {
        ...state,
        index: action.index
      };
    case CLEAR_INDEX_AND_DISTRICT:
      return {
        ...state,
        index: [],
        district: [],
        city: [],
        street: [],
        banks: []
      };
    case CLEAR_CITY_STREET_BANKS:
      return {
        ...state,
        city: [],
        street: [],
        banks: []
      };
    //fact address
    case SUCCESS_SET_DISTRICT_FACT:
      return {
        ...state,
        district_fact: action.district_fact
      };
    case SET_STREET_FACT:
      return {
        ...state,
        street_fact: action.street_fact
      };
    case SUCCESS_SET_CITY_FACT:
      return {
        ...state,
        city_fact: action.city_fact
      };
    case SET_INDEX_FACT:
      return {
        ...state,
        index_fact: action.index_fact
      };
    case CLEAR_INDEX_AND_DISTRICT_FACT:
      return {
        ...state,
        index_fact: [],
        district_fact: [],
        city_fact: [],
        street_fact: [],
        banks: []
      };
    case CLEAR_CITY_STREET_BANKS_FACT:
      return {
        ...state,
        city_fact: [],
        street_fact: [],
        banks: []
      };
    case GET_ERRORS:
      return Object.assign({}, state, {
        error: action.error
      });
    default:
      return state;
  }
}
